<template>
  <div
    class="form-check form-switch"
    :class="className"
  >
    <input
      :id="id"
      class="form-check-input"
      :checked="internalValue"
      type="checkbox"
      role="switch"
      :value="value"
      @change="setValue"
      :disabled="disabled"
    >
    <label
      v-if="label"
      :for="id"
      class="form-check-label"
    >
      {{ label }}
    </label>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    internalValue: false
  }),
  watch: {
    value (val) {
      this.internalValue = val
    },
    internalValue (val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    this.internalValue = this.value
  },
  methods: {
    setValue () {
        if (!this.disabled) {
            this.$emit('input', !this.value)
            this.$emit('change', !this.value)
        }

    }
  }
}
</script>

<style lang="scss" scoped>
.form-check.form-switch {
    display: flex;
    align-items: center;

    .form-check-input[type="checkbox"] {
        width: 41px;
        height: 27px;
        cursor: pointer;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e");
        background-color: #C2C1C1;
        border-color: #C2C1C1;
    }
    .form-check-input:checked {
        background-color: #16c10e;
        border-color: #16c10e;
    }
    .form-check-label {
        margin-left: 20px;
        font-size: 14px;
    }
}
</style>
